import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught in ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <div className="container" style={{ minHeight: "100vh" }}>
        <div className="d-flex align-items-center justify-content-center flex-column">
          <h1 className="display-1 fw-bold text-primary text-center">500</h1>
          <h2 className="display-5 text-center fw-semibold">Oops!</h2>
          <h2 className="display-5 text-center fw-semibold">Internal Server Error</h2>
          <p className="lead text-muted text-center fw-medium">Something went wrong on our end. Please try again later.</p>
        </div>
      </div>
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
